<template>
  <div class="homePage">
      <a-layout>

<!-- sider模块=============begin============= -->
    <a-layout-sider>
<!-- sider->下拉框模块=============begin============= -->
<div>
    <a-select v-model="engineerName" style="width: 180px" @change="handleChange">
      <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">
       {{item.engineeringName}}
      </a-select-option>
    </a-select>   
  </div>
<!-- sider->下拉框模块===============end============= -->
<!-- sider->tree模块=============begin============= -->
    <a-tree
      v-model="checkedKeys"
      checkable
      :expanded-keys="expandedKeys"
      :auto-expand-parent="autoExpandParent"
      :selected-keys="selectedKeys"
      :tree-data="treeData"
      @expand="onExpand"
      @select="onSelect"
    />
<!-- sider->tree模块=============end============= -->
    </a-layout-sider>
<!-- sider模块=============end============= -->

    <a-layout>
<!-- content模块=============begin============= -->
      <a-layout-content>
<!-- content 对话框模块=============begin============= -->
        <div>
        <div style="height:40px;width:100%">
          <a-button type="primary" @click="showModal">
            添加人员
          </a-button>

          <a-button type="primary" @click="showModal">
            删除人员
          </a-button>
        </div>
          <a-modal
            title="添加/编辑组织"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
          >
            <template>
              上级组织：<a-input placeholder="Basic usage" />
            </template>
            <template>
              组织类型：<a-input placeholder="Basic usage" />
            </template>
            <template>
             组织名称：<a-input placeholder="Basic usage" />
            </template>
            <template>
              备注：<a-input placeholder="Basic usage" />
            </template>
          </a-modal>
        </div>
<!-- content 对话框模块=============end============= -->
<!-- content 列表模块=============begin============= -->
        <a-table :row-selection="rowSelection" :columns="columns" :pagination="pagination" :data-source="userList">
          <a slot="id" slot-scope="text">{{ text }}</a>
        </a-table>
<!-- content 列表模块=============end============= -->
      </a-layout-content>
<!-- content模块=============end============= -->
    </a-layout>
  </a-layout>
  </div>
</template>
<script>
import mix from "./HomePage-mixins";
export default {
  mixins: [mix],
  components: {}
};
</script>
<style lang="less" scoped>
@import "./HomePage.less";
</style>



// WEBPACK FOOTER //
// src/views/HomePage/HomePage.vue